import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as componentStore from '../component-store'
import * as metric from '../metric'

/**
 * Displays a report card component
 */
@ngCore.Component({
  imports: [
    ds.layout.section.Component,
    ds.layout.widget.Component,
    ds.illustration.emptyState.Component,
    metric.Component,
  ],
  selector: 'widget-report-card',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link componentStore.Widget} */
  public readonly widgetStore = ngCore.inject(
    componentStore.Widget<ents.core.mosaic.Widget.Type.ReportCard>,
  )
}
